import { createSubscriptionHook } from '~/shared/providers/api';

export const useFilesystemChangedSubscription = createSubscriptionHook(
  'files.filesystemChanged',
  () => ({
    filesFilesystemChanged: {
      file: true,
      parent: true,
    },
  }),
  {
    select: ({ filesFilesystemChanged }) => filesFilesystemChanged,
  },
);
